var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:_vm.styleClass,attrs:{"type":_vm.type,"variant":_vm.variant,"disabled":_vm.loading || _vm.disabled}},[_vm._v("\n  "+_vm._s(_vm.loadingLabelString)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }